export default __webpack_public_path__ + "static/media/RoutePage2.ea5852e2.txt";